import React, { useEffect } from "react";
import {
  useNavigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
// Styles
import useStyles from "assets/jss/material-react/views/italmundoStyles";
// Components
import { Box, Button } from "@mui/material";
import PageContainer from "../../components/PageContainer/PageContainer";
import { Redireccion } from "../../components/Modals";
// Assets
import { MercadoPagoImg } from "assets";
// Service
import ClientService from "services/clientService";

import { getSessionDocument } from "services/sessionStorageService";
import { URLs, getURLDespedida, redirectStep } from "../../utils/redirectStep";
import { saveSessionPasoPago } from "services/sessionStorageService";
const baseUrlCanonical = window.baseUrlCanonical;

function CostoDeActivacion() {
  //Inicializaciones base
  const clientService = new ClientService();
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = React.useState(false);
  const [modal, setModal] = React.useState({
    open: false,
    title: "",
    message: "",
    content: null,
  });

  // Inicializaciones particulares
  const [searchParams, setSearchParams] = useSearchParams();
  const utmClient = searchParams.get("utm_source");

  const urlDespedida = getURLDespedida(utmClient);
  const currentPathSegment = window.location.pathname.split("/")[1];
  console.log(currentPathSegment);
  const handleModalCloseClick = () => {
    setModal({ ...modal, open: false });
    navigate(URLs.home);
  };
  const buildNavigateUrl = (path) => {
    const params = new URLSearchParams(searchParams);
    return `${path}?${params.toString()}`;
  };

  // para redirigir
  useEffect(() => {
    const checkAndRedirect = async () => {
      const documento = getSessionDocument();
      try {
        const response = await clientService.evaluateDocument(documento);
        const codigoEstado = response.data.codigoEstado;
        const transaction = {
          ...response.data,
        };        
        if (codigoEstado === 14) {
          openModalPagoPendiente(response.message);
        } else if (codigoEstado === 6) { // estamos en el codigo estado de la misma pantalla, entonces no debe redirigir
          const pagoAnticipadoo = location?.state?.transaction?.pagoAnticipado;
            openModalMetodoDePago(pagoAnticipadoo); 
        }else {
          openModalRedirect();
          setTimeout(async () => {
            await redirectStep(codigoEstado, transaction, navigate);
          }, 3000);
        }
      } catch (error) {
        console.log(error);
      }
    };
    checkAndRedirect();
  }, []);

  const openModalRedirect = () => {
    setModal({
      open: true,
      showX: false,
      content: <Redireccion />,
    });
  };

  const openModalPagoPendiente = (responseMessage) => {
    const message = responseMessage;
    setModal({
      open: true,
      showX: true,
      message: message,
    });
  };

  const handleRedDePagosClick = async (monto) => {
    setLoading(true);
    try {
      const transaction = location?.state?.transaction;
      const formData = {
        idMetodoPago: 2,
      };
      await clientService.confirmPaymentMethod(formData, transaction);
      saveSessionPasoPago("redDePago");
      navigate(buildNavigateUrl(URLs.redesDeCobranza), {
        state: { transaction: { tipoTarjeta: "plata-" + monto } },
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleMercadoPagoClick = async (monto) => {
    setLoading(true);
    const transaction = location.state.transaction;
    const formData = {
      success: buildNavigateUrl(baseUrlCanonical + urlDespedida),
      failure: buildNavigateUrl(
        baseUrlCanonical +
          URLs.error +
          "/" +
          transaction.transactionId +
          "/" +
          transaction.document +
          "/" +
          transaction.idLead +
          "/" +
          monto
      ),
      pending: buildNavigateUrl(baseUrlCanonical + URLs.pendiente),
    };
    try {
      const response = await clientService.mercadoPagoPreference(
        formData,
        transaction
      );
      if (response && response.data && response.data.urlLinkPago) {
        saveSessionPasoPago("mercadoPago");
        window.location.href = response.data.urlLinkPago;
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const openModalMetodoDePago = (monto) => {
    setModal({
      open: true,
      showX: false,
      content: (
        <Box className={classes.modalContentDynamic}>
          <p className={classes.modalTitle}>
            Solo queda abonar el
            <br />
            <span style={{ color: "#04808F", fontWeight: 600 }}>
              pago anticipado de $<span className="special-font">{monto}</span>
            </span>
          </p>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              marginTop: "1rem",
            }}
          >
            <div className={classes.divBtn}>
              <Button
                className={`${classes.btnFull} ${classes.btnAzul}`}
                onClick={() => handleMercadoPagoClick(monto)}
                variant="text"
                sx={{
                  width: "200px",
                }}
              >
                {"PAGO ONLINE"}
                <img
                  src={MercadoPagoImg}
                  alt="Home Mobile"
                  style={{
                    maxWidth: "50px",
                    maxHeight: "100%",
                    objectFit: "contain",
                    marginLeft: "0.5rem",
                  }}
                />
              </Button>
            </div>
            <div className={classes.divBtn}>
              <Button
                className={`${classes.btnFull} ${classes.btnAzul}`}
                onClick={() => handleRedDePagosClick(monto)}
                variant="text"
                sx={{
                  width: "200px",
                  marginTop: "10px",
                }}
              >
                {"REDES DE COBRANZA"}
              </Button>
            </div>
          </Box>
        </Box>
      ),
    });
  };

  return (
    <PageContainer
      loading={loading}
      modal={modal}
      handleModalCloseClick={handleModalCloseClick}
      canonicalUrl={URLs.costoDeActivacion}
      noImage={true}
    ></PageContainer>
  );
}

export default CostoDeActivacion;
